import { InjectionToken } from '@angular/core';
import { ResultInterface } from '@campus/dal';

export const RESULT_UPDATER_TOKEN = new InjectionToken<ResultUpdater>('ExerciseStoreService');

export type ResultUpdater = (result: ResultInterface, finalUpdate?: boolean) => void;
